import React from "react";

import { connect } from "react-redux";
import {
    Button,
    Typography,
    CardMedia,
    CardContent,
    CardActions,
    Card
} from "@material-ui/core";

export class SecurityModal extends React.Component {
    goBack = () => {
        this.props.history.goBack();
    };
    render() {
        // const { errType, errPage } = this.props;
        return (
            <Card
                style={{
                    maxWidth: 350,
                    margin: "0 auto",
                    display: "block",
                    position: "relative"
                }}
            >
                <CardMedia
                    style={{ height: 160 }}
                    image={require("./warning.png")}
                    title="Contemplative Reptile"
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        Sorry, You do not have permission to view this page.
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                    >
                        This may be due to your security access level not
                        permitting you to access this page or this page does not
                        exist. Please contact your administrator.
                    </Typography>
                </CardContent>

                <CardActions>
                    <Button
                        size="small"
                        color="primary"
                        onClick={() => {
                            this.goBack();
                        }}
                    >
                        Return to Previous Page
                    </Button>
                </CardActions>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {};
    },
    {}
)(SecurityModal);
